<template>
  <div class="app-container" style="text-align: left">
    <div>
      <span style="
          border-bottom: 2px solid #2cafe7;
          font-size: 16px;
          color: black;
          padding-bottom: 4px;
          padding-left: 10px;
          padding-right: 10px;
        ">注册推广链接</span>
      <hr color="#dcdfe6" width="100%" />
      <div class="register-url-container">
        <!-- <el-input disabled v-model="registerUrl"></el-input> -->
        <div class="register-url-text">
          {{ registerUrl }}
        </div>
        <el-button 
          type="primary" 
          size="small"
          icon="el-icon-document-copy"
          @click="copyRegisterUrl"
          style="
            font-size: 13px;
            background-color: #409eff;
            color: white;
            height: 38px;
            border-radius: 0.4em;
          "
        >复制链接</el-button>
        <div class="yongjin-container">
          佣金金额：<span>{{ yongjin }}</span>
        </div>
        <div class="yongjin-apply-container">
          <el-button type="primary" style="
              font-size: 13px;
              background-color: #0850fc;
              color: white;
              height: 38px;
              border-radius: 0.4em;
            " @click="yongjinApply">佣金申请</el-button>
        </div>
      </div>
      
    </div>
    <br />
    <span style="
        border-bottom: 2px solid #2cafe7;
        font-size: 16px;
        color: black;
        padding-bottom: 4px;
        padding-left: 10px;
        padding-right: 10px;
        margin-top: 20px;
      ">卡密推广</span>
    <hr color="#dcdfe6" width="100%" />
    <div style="margin-top: 15px; height: 48px">
      <div class="platDiv" @click="addClass('1')" :class="{ spanColors: platform === '1' }">
        <img src="@/assets/tb.png" style="position: relative; width: 30px; height: auto; margin-left: -2.3px" />
        <span class="platSpan">淘宝</span>
      </div>
      <div class="platDiv" style="width: 96px" @click="addClass('2')" :class="{ spanColors: platform === '2' }">
        <img src="@/assets/pdd.png" style="
            position: relative;
            width: 30px;
            height: auto;
            margin-left: -2px;
            margin-top: -1px;
          " />
        <span class="platSpan">拼多多</span>
      </div>
      <div class="platDiv" @click="addClass('3')" :class="{ spanColors: platform === '3' }">
        <img src="@/assets/dy.png" style="
            position: relative;
            width: 30px;
            height: auto;
            margin-left: -2px;
            margin-top: -1px;
          " />
        <span class="platSpan">抖音</span>
      </div>
    </div>
    代发仓库：
    <el-select style="width: 400px" v-model="kamiCreate.pingtai_data_id" @change="cangkuClick" placeholder="代发仓库"
      class="filter-item">
      <el-option v-for="item in cangkuList" :key="item.id" :label="item.desc_name" :value="item.id">
        <span>
          <img v-if="item.kuaidi && item.kuaidi.pic" :src="item.kuaidi.pic" alt="" style="width: 60px; height: 30px; margin-right: 8px" />
          {{ item.desc_name }}
        </span>
      </el-option>
    </el-select>
    &nbsp;&nbsp;&nbsp; 单价：<el-input v-model="price" style="width: 80px" :readonly="true"></el-input>
    &nbsp;&nbsp;&nbsp; 条数：<el-select v-model="kamiCreate.strip" style="width: 90px" class="filter-item"
      @change="stripOrZhangChange">
      <el-option v-for="(item, index) in stripList" :key="index" :label="item" :value="item" />
    </el-select>
    &nbsp;&nbsp;&nbsp; 张数：<el-input v-model="kamiCreate.zhang" style="width: 90px" placeholder="0" class="input-num"
      :min="0" onkeyup="this.value = this.value.replace(/^(0+)|[^\d]+/g,'')" @blur="stripOrZhangChange" />
    &nbsp;&nbsp;&nbsp; 金额：<el-input v-model="totalMoney" style="width: 80px" :readonly="true"></el-input>
    <el-input v-model="kamiCreate.money" style="width: 80px" :readonly="true" v-show="false"></el-input>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <el-button type="primary" style="
        font-size: 13px;
        background-color: #0850fc;
        color: white;
        height: 38px;
        border-radius: 0.4em;
      " @click="creatKami">生成卡密</el-button>
    <br /><br />
    状态：<input type="radio" :value="0" v-model="listQuery.status" />
    <label>未充值</label>&nbsp;&nbsp;
    <input type="radio" :value="1" v-model="listQuery.status" /> <label>已充值</label>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <el-button icon="el-icon-search" type="primary" style="
        font-size: 13px;
        background-color: #0850fc;
        color: white;
        height: 38px;
        border-radius: 0.4em;
      " @click="getList(1)">卡密列表</el-button>
    <el-button icon="el-icon-download" type="primary" :loading="downloadLoading1" style="
        font-size: 13px;
        background-color: white;
        color: #0850fc;
        height: 38px;
        border-radius: 0.4em;
        padding: 0 0 0 6px;
      " @click="exportExcel(1)">导出（已充值）</el-button>
    <!-- <a
        type="button"
        href="http://cs2.cainiaolipin.cn/api/index/export?status=1"
        class="btn btn-link"
        name="exec1"
        value="1"
        >导出EXECL(已充值)</a
      > -->
    <el-button icon="el-icon-download" type="primary" :loading="downloadLoading" style="
        font-size: 13px;
        background-color: white;
        color: #0850fc;
        height: 38px;
        border-radius: 0.4em;
        padding: 0 0 0 6px;
      " @click="exportExcel(0)">导出（未充值）</el-button>

    <el-table v-show="this.listQuery.button == 1" v-loading="listLoading" :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="list"
      highlight-current-row style="color: rgb(70, 70, 70); margin-top: 10px" :row-style="{ height: '0' }"
      :cell-style="{ padding: '3px 0' }" :header-cell-style="{
        background: 'rgb(247 248 252) !important',
        color: '#ededed  !important',
        padding: '7px 0',
        color: 'rgb(140, 140, 140)',
      }">
      <el-table-column label="ID" align="left" min-width="1">
        <template slot-scope="{ row }">
          <span>{{ row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="卡密号" min-width="3" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.no">{{ row.no }}</span>
        </template>
      </el-table-column>
      <el-table-column label="快递仓库" min-width="3" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.pingtai_data_cang">{{
            row.pingtai_data_cang
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="单数" min-width="1" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.strip }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" min-width="1" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.money }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否充值" min-width="1" align="left">
        <template slot-scope="{ row }">
          <span>{{ isApplyed }}</span>
        </template>
      </el-table-column>
      <el-table-column label="使用者账户" min-width="2" align="left">
        <template slot-scope="{ row }">
          <span v-if="row.user != null">{{ row.user.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="生成时间" min-width="2" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.created_at">{{ row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="使用时间" min-width="2" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.updated_at">{{ row.updated_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="1" align="left" v-if="isShow">
        <template slot-scope="{ row, $index }">
          <el-button type="primary" style="padding-left: 8px; padding-right: 8px" size="mini" @click="quitKami(row)">
            申请退卡
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total > 0 && this.listQuery.button == 1" :total="total" :page.sync="listQuery.page"
      layout="total, prev, pager, next" style="padding-top: 12px; padding-bottom: 0px; text-align: center"
      @pagination="getList(1)" />
    <!-- 佣金申请弹出框 -->
    <el-dialog title="佣金申请" :visible.sync="dialogFormVisible" style="width: 60%; margin-left: 20%">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-width="100px" style="width: 90%">
        <el-form-item label="申请金额" prop="money">
          <el-input v-model="temp.money" class="input-num"
            onkeyup="this.value = this.value.replace(/[^\d.]/g,'').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')"
            onafterpaste="this.value=this.value.match(/\d+/)" @blur="getValueData" :min="0.0" :controls="false"
            :precision="0.0" />
        </el-form-item>

        <el-form-item label="手机号" prop="phone"><el-input v-model="temp.phone" /></el-form-item>
        <el-form-item label="备注" prop="ext"><el-input v-model="temp.ext" /></el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false"> 取消 </el-button>
        <el-button type="primary" @click="addYongJinList()"> 提交 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination

export default {
  name: "dltg",
  components: {
    Pagination,
  },
  filters: {
    // statusFilter(status) {
    //   const statusMap = {
    //     1: "已充值",
    //     0: "未充值",
    //   };
    //   return statusMap[status];
    // },
    handleFilter(status) {
      const handleMap = {
        1: "已处理",
        0: "未处理",
      };
      return handleMap[status];
    },
  },
  data() {
    return {
      userList: [],
      cangkuList: [],
      kamiCreate: { pingtai_data_id: "", strip: 0, zhang: 1, money: "" },
      totalMoney: "",
      stripList: [0, 50, 100, 200, 300, 500, 1000, 2000, 5000],
      price: "",
      list: [],
      total: 0,
      yongjinList: [],
      yongjinTotal: 0,
      yjsqList: [],
      yjsqTotal: 0,
      listLoading: false,
      loadingText: "拼命加载中",
      // listQuery: { button: 1, status: 0, page: 1, per_page: 15 },
      btn_val: 1,
      listQuery: {
        page: 1,
        per_page: 15,
        button: 1,
        status: 0,
      },
      registerUrl: "",
      yongjin: 0,
      dialogFormVisible: false,
      temp: {
        money: 0,
        phone: "",
        ext: "",
      },
      rules: {
        money: [{ required: true, message: "申请金额不能为空", trigger: "blur" }],
        phone: [{ required: true, message: "手机号不能为空", trigger: "blur" }],
        ext: [{ required: true, message: "备注不能为空", trigger: "blur" }],
      },
      isShow: true,
      isApplyed: "未充值",
      downloadLoading: false,
      downloadLoading1: false,
      exportList: [],
      platform: 1,
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      // this.$confirm("请先登录再使用！", "提示", {
      //   confirmButtonText: "确定",
      // })
      //   .then(() => {
      //     // 重新导航到登录页面
      //     localStorage.clear();
      //     this.$root.removeCookies();
      //     this.$router.push({ path: "/login" });
      //   })
      //   .catch(() => {
      //     // 重新导航到首页
      //     localStorage.clear();
      //     this.$root.removeCookies();
      //     this.$router.push({ path: "/" });
      //   });
      // return;
    } else {
      // this.getCk();
      this.getList(1);
      this.addClass("1");
    }
    // this.$root.getUserInfo();
    let code = Cookies.get("view_code");
    if (code == undefined) {
      code = "";
    }
    this.registerUrl = "http://" + this.$root.localUrl + "/#/register?uid=" + code;
    this.yongjin = Cookies.get("view_yongjin");

    if (this.yongjin == null || this.yongjin == "" || this.yongjin == "null") {
      this.yongjin = 0;
    }
  },
  methods: {
    getList(btn) {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            Cookies.set("view_historyPath", "/dltg", { expires: 1 });
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.listQuery.button = btn;

      this.list = [];
      this.yongjinList = [];
      this.yjsqList = [];
      // this.total = 0;
      // this.yongjinTotal = 0;
      // this.yjsqTotal = 0;

      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/kami";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.listQuery,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            if (btn == 1) {
              this.list = resd.data.data;
              this.total = resd.data.total;
              if (this.listQuery.status == 1) {
                this.isShow = false;
                this.isApplyed = "已充值";
              } else {
                this.isShow = true;
                this.isApplyed = "未充值";
              }
            }
            this.listLoading = false;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => { });
          }
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 3 * 1000);
    },
    getCk() {
      //更换平台时，调用接口获取平台对应仓库列表
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      const url = this.$root.commonPreUrl + "/index/getCk";
      const system_id = Cookies.get("view_system_id");
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: { platform: this.platform, system_id: system_id },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.cangkuList = resd.data;
            this.cangkuList.forEach((item) => {
              // 快递图标加前缀
              if (item.kuaidi && item.kuaidi.pic) {
                item.kuaidi.pic = this.$root.staticUrl + "storage/" + item.kuaidi.pic;
              }
              // 仓库名称后面加上价格展示
              item.desc_name = item.desc_name + "，￥" + item.processed_member;
            });
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => { });
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    cangkuClick() {
      const selected_cid = this.kamiCreate.pingtai_data_id;
      // 使用forEach方法遍历数组并取值
      this.cangkuList.forEach((item, index) => {
        const cid = item.id;
        if (cid == selected_cid) {
          // 单价
          this.price = item.processed_member;
          // 总金额
          this.totalMoney = (
            this.price *
            this.kamiCreate.strip *
            this.kamiCreate.zhang
          ).toFixed(2);
          // 向后台传值单张金额
          this.creatKami.money = (this.price * this.kamiCreate.strip).toFixed(2);
        }
      });
    },
    creatKami() {
      //更换平台时，调用接口获取平台对应仓库列表
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }
      const url = this.$root.commonPreUrl + "/index/creatKami";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.kamiCreate,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (response.status == "200") {
            this.$notify({
              title: "成功",
              message: "已生成，可在列表查看",
              type: "success",
              duration: 2000,
            });
            // this.getList(1);
            window.location.reload();
          } else {
            this.$confirm(response.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => { })
              .catch(() => { });
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => { });
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    // getUserInfo() {
    //   const url = this.$root.commonPreUrl + "/index/getUserInfo";
    //   const userToken = Cookies.get("view_userToken");
    //   const res = axios.get(url, {
    //     headers: {
    //       Authorization: "Bearer " + userToken,
    //     },
    //   });
    //   res
    //     .then((response) => {
    //       const resd = response.data;
    //       if (resd.code == "200") {
    //         this.registerUrl =
    //           "http://" + resd.data.url + "/register?uid=" + resd.data.code;
    //         this.yongjin = resd.data.yongjin;
    //       }
    //       setTimeout(() => {
    //         return;
    //       }, 1.5 * 1000);
    //     })
    //     .catch((error) => {
    //       console.error("初始请求失败:", error);
    // if (
    //   JSON.stringify(error).includes("Error: Request failed with status code 401")
    // ) {
    //   this.$confirm("请先导入收货地址信息再生成单号!", "提示", {
    //     confirmButtonText: "确认",
    //     showCancelButton: false, //是否显示取消按钮
    //   })
    //     .then(() => {
    //       // 重新导航到首页
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/login" });
    //     })
    //     .catch(() => {});
    // }
    //
    //       return;
    //     });
    // },
    stripOrZhangChange() {
      // 总金额
      this.totalMoney = (
        this.price *
        this.kamiCreate.strip *
        this.kamiCreate.zhang
      ).toFixed(2);

      this.kamiCreate.money = (this.price * this.kamiCreate.strip).toFixed(2);
    },
    exportExcel(status) {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      if (status == 0) {
        this.downloadLoading = true;
      } else if (status == 1) {
        this.downloadLoading1 = true;
      }
      const url = this.$root.commonPreUrl + "/index/export";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: { status: status },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.exportList = resd.data;

            import("@/vendor/Export2Excel").then((excel) => {
              // ID	卡密号	快递仓库	单数	金额	使用者账户	是否充值	生成时间	使用时间
              const tHeader = [
                "ID",
                "卡密号",
                "快递仓库",
                "单数",
                "金额",
                "是否充值",
                "生成时间",
                "使用时间",
              ];
              const filterVal = [
                "id",
                "no",
                "pingtai_data_id",
                "strip",
                "money",
                "chongzhi_id",
                "created_at",
                "updated_at",
              ];
              const data = this.formatJson(filterVal);
              let fname = "";
              if (status == 0) {
                fname = "(未充值)卡密列表";
              } else if (status == 1) {
                fname = "(已充值)卡密列表";
              }
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: fname,
              });
              if (status == 0) {
                this.downloadLoading = false;
              } else if (status == 1) {
                this.downloadLoading1 = false;
              }
            });
          } else {
            this.$confirm(resd.msg, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => { })
              .catch(() => { });
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => { });
          }

          return;
        });
    },
    formatJson(filterVal) {
      return this.exportList.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    yongjinApply() {
      this.dialogFormVisible = true;
    },
    copyRegisterUrl() {
      if (!this.registerUrl) {
        this.$message.warning("链接地址为空");
        return;
      }
      const textarea = document.createElement("textarea");
      textarea.value = this.registerUrl;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      try {
        const successful = document.execCommand("copy");
        if (successful) {
          this.$message.success("链接已复制到剪贴板");
        } else {
          this.$message.error("复制失败，请手动复制");
        }
      } catch (err) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(this.registerUrl).then(
            () => {
              this.$message.success("链接已复制到剪贴板");
            },
            () => {
              this.$message.error("复制失败，请手动复制");
            }
          );
        } else {
          this.$message.error("浏览器不支持复制功能，请手动复制");
        }
      } finally {
        document.body.removeChild(textarea);
      }
    },
    addYongJinList() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      const yongjin = this.temp.money;
      if (yongjin <= 0) {
        // alert("申请金额金不能等于0，请正确填写金额！");
        this.$confirm("申请金额金不能等于0，请正确填写金额！", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false, //是否显示取消按钮
        })
          .then(() => {
            return;
          })
          .catch(() => { });
        return;
      }
      const url = this.$root.commonPreUrl + "/index/addYongJinList";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.temp,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == 200) {
            // if (resd.code == "200") {
            this.$notify({
              title: "成功",
              message: resd.message,
              type: "success",
              duration: 2000,
            });
            this.dialogFormVisible = false;
          } else {
            this.$confirm(resd.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => { })
              .catch(() => { });
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => { });
          }

          return;
        });
    },
    // 这操作是如果是小数0点多，那就不理它，但是如果是0+一个数字，那么就把这个0去掉
    getValueData() {
      if (this.temp.money) {
        let a = this.temp.money.substring(0, 1);
        let b = this.temp.money.substring(1, 2);
        if (a == "0" && b != ".") {
          this.temp.money = this.temp.money.slice(1);
        }

        // 使用正则表达式来匹配非数字字符，并替换为空字符串
        let value = this.temp.money
          .replace(/[^\d.]/g, "")
          // 匹配两个或更多的小数点
          .replace(/\.{2,}/g, ".")
          // 只保留第一个小数点后的两位
          .replace(/[^\d.]|(\.\d{2}).*/, "$1");
        this.temp.money = value;
      }
    },
    quitKami(row) {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.$confirm("确定要申请退卡吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.loadingText = "退卡中，请稍后...";
          this.listLoading = true;
          const yongjin = this.temp.money;
          if (row.chongzhi_id != 0) {
            // alert("卡密已经充值 不支持直接退款！");
            this.$confirm("卡密已经充值 不支持直接退款！", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                return;
              })
              .catch(() => { });
            return;
          }
          const url = this.$root.commonPreUrl + "/index/quitKami";
          const res = axios.get(url, {
            headers: {
              Authorization: "Bearer " + userToken,
            },
            params: { id: row.id },
          });
          res
            .then((response) => {
              this.listLoading = false;
              const resd = response.data;
              if (resd.code == "200") {
                this.$notify({
                  title: "成功",
                  message: resd.message,
                  type: "success",
                  duration: 2000,
                });
                // this.getList(1);
                window.location.reload();
              } else {
                // alert(resd.message);
                this.$confirm(resd.message, "提示", {
                  confirmButtonText: "确认",
                  showCancelButton: false, //是否显示取消按钮
                })
                  .then(() => {
                    return;
                  })
                  .catch(() => { });
              }
              setTimeout(() => {
                return;
              }, 1.5 * 1000);
            })
            .catch((error) => {
              console.error("初始请求失败:", error);
              if (
                JSON.stringify(error).includes(
                  "Error: Request failed with status code 401"
                )
              ) {
                this.$confirm("登录信息已失效，请重新登录!", "提示", {
                  confirmButtonText: "确认",
                  showCancelButton: false, //是否显示取消按钮
                })
                  .then(() => {
                    // 重新导航到首页
                    localStorage.clear();
                    this.$root.removeCookies();
                    this.$router.push({ path: "/login" });
                  })
                  .catch(() => { });
              }

              return;
            });
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
        });
    },
    addClass: function (plat) {
      this.platform = plat;
      this.getCk();
    },
  },
};
</script>

<style scoped>
/* .el-main {
  height: 89vh;
  width: 98.4vw;
  margin-top: 1.5vh;
  background-color: white;
  margin-left: 0.8vw;
  margin-right: 0.8vw;
  text-align: left;
} */
.register-url-container {
  display: flex;
  align-items: center;
  gap: 30px;
  margin-top: 15px;
}
.register-url-text {
  font-size: 14px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: #eee;
  padding: 8px 20px;
  border-radius: 5px;
}
.yongjin-container {
  font-size: 14px;
  color: #333;
}
.yongjin-apply-container {
  margin-left: 10px;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 100%;
  vertical-align: middle;
}

.platDiv {
  width: 80px;
  height: 32px;
  border: #0850fc solid 1px;
  border-radius: 0.5em;
  float: left;
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
  margin-right: 20px;
}

.platSpan {
  font-size: 16px;
  padding: 0px 7px;
}

.spanColors {
  font-weight: bold;
  background-color: #0850fc;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/dltg/zctg/index.vue